import React, { ReactNode } from 'react';
import { Field } from 'react-final-form';

import { Textarea, ValidationMessage } from '@xsolla/ui-core';

import { FlexParentBlock } from '../../../styled';
import { FieldInputTitle, FullWideContentBlock, TextareaSublabel } from './style';

type Props = {
  label?: ReactNode;
  sublabel?: ReactNode;
  extraRight?: ReactNode;
  errorMessage?: ReactNode | string;
  resize?: boolean;
  name: string;
};

const FieldTextarea = ({
  label,
  sublabel,
  extraRight,
  errorMessage,
  name,
  ...props
}: Props): JSX.Element => {
  return (
    <>
      <FieldInputTitle>{label}</FieldInputTitle>
      <FlexParentBlock>
        <FullWideContentBlock>
          <Field name={name}>
            {({ input, meta }) => (
              <>
                <Textarea value={input.value} onChange={input.onChange} {...props} />

                {sublabel && <TextareaSublabel>{sublabel}</TextareaSublabel>}

                <ValidationMessage>
                  {(meta.modified || meta.submitFailed) && errorMessage}
                </ValidationMessage>
              </>
            )}
          </Field>
        </FullWideContentBlock>
        {extraRight}
      </FlexParentBlock>
    </>
  );
};

export default FieldTextarea;
